import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import pageTitle from 'ember-page-title/helpers/page-title';
import type RouterService from '@ember/routing/router-service';

const INDEX_ROUTE = 'authenticated.pslf.dashboard.index';

export default class PslfDashboardTemplate extends Component {
  @service declare router: RouterService;

  /**
   * True on the PSLF landing route, whose own template renders the hero that
   * carries the page's single h1. The wizard and detail children have no
   * heading of their own, so they take this template's plain header row.
   */
  get isIndex() {
    return this.router.currentRouteName === INDEX_ROUTE;
  }

  <template>
    {{pageTitle "PSLF" prepend=false}}
    <VStack class="gap-8">
      {{#unless this.isIndex}}
        <PageHeader @title={{t "pslf.default_full"}} />
      {{/unless}}
      {{outlet}}
    </VStack>
  </template>
}
